
const responsiveBackgroundImages = () => {
  const elements = document.querySelectorAll('[responsive-background-image]');
  for (let i = 0; i < elements.length; i++) {
    const element = elements[i];
    const img = element.querySelector('img');
    if (img !== null) {
      const src = typeof img.currentSrc !== 'undefined' ? img.currentSrc : img.src;
      element.style.backgroundImage = `url(${src})`;
    }
    setTimeout(() => {
      element.classList.add('loaded');
    }, 500);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  // responsiveBackgroundImages();
});

export default responsiveBackgroundImages;



// WEBPACK FOOTER //
// ./assets/js/src/responsive-images.js